// extracted by mini-css-extract-plugin
module.exports = {"root":"widgetNav_root___O7om","cardRoot":"widgetNav_cardRoot__L3nHB","cardContent":"widgetNav_cardContent__22Be2"};